import { Dispatch, SetStateAction, useEffect } from "react"
import { FetchPolicy } from "relay-runtime"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"
import { Language } from "@/modules/patients/services/__generated__/PatientAppointmentFragment.graphql"
import { usePatientEpisodesOfCareQuery } from "@/modules/patients/services/usePatientEpisodesOfCareQuery"
import { ProgressNoteKind } from "@/types/__generated__/union-types"

export const usePatientEpisodesOfCare = (
  patientId: string,
  appointmentId: string | null,
  isEditMode: boolean,
  kind: ProgressNoteKind,
  language: Language,
  fetchKey: number,
  isRefetch: boolean,
  setIsRefetch: Dispatch<SetStateAction<boolean>>,
) => {
  const country = useCountryParam()

  const fetchPolicy: FetchPolicy = isRefetch ? "network-only" : "store-or-network"

  const [patientEpisodesOfCareData] = usePatientEpisodesOfCareQuery(
    patientId,
    appointmentId,
    isEditMode,
    country,
    kind,
    language,
    fetchKey,
    fetchPolicy,
  )

  useEffect(() => {
    setIsRefetch(false)
  }, [isRefetch, setIsRefetch])

  return patientEpisodesOfCareData
}
